import { render, staticRenderFns } from "./changePasswordComponent.vue?vue&type=template&id=cd8bd776&scoped=true&"
import script from "./changePasswordComponent.vue?vue&type=script&lang=js&"
export * from "./changePasswordComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd8bd776",
  null
  
)

export default component.exports